/**
 * JINS NEW CLASSIC 26SS — Landing Page JS
 * File: assets/new-classic-26ss.js
 * ============================================================
 * FEATURES:
 *   1. Page guard
 *   2. Device detection (SP / PC)
 *   3. KV hero crossfade
 *   4. Inview IntersectionObserver
 *   5. Sticky No. Nav (show/hide on scroll)
 *   6. Sticky Side Nav (show/hide + section is-current)
 *   7. Inline Side Nav (section is-current)
 *   8. Vanilla carousel (main + detail sliders)
 *   9. Detail section parallax
 *  10. Visual middle parallax
 *  11. Progress bar animation (basiclineup thumbnails)
 * ============================================================
 * NO DEPENDENCIES: no Swiper, no GSAP, no Lenis, no jQuery
 * ============================================================
 */

document.addEventListener('DOMContentLoaded', function () {

  // ============================================================
  // 1. PAGE GUARD — only run on this page
  // ============================================================
  var root = document.getElementById('jins-new-classic-26ss');
  if (!root) return;


  // ============================================================
  // 2. DEVICE DETECTION
  // ============================================================
  var device = window.innerWidth <= 767 ? 'SP' : 'PC';
  window.addEventListener('resize', function () {
    device = window.innerWidth <= 767 ? 'SP' : 'PC';
  });

  // prefers-reduced-motion — disables parallax + animations if true
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;


  // ============================================================
  // 3. KV HERO — Two static panels, no crossfade needed
  //    JS reserved for future zoom/parallax enhancement
  // ============================================================
  function jtNcInitKV() {
    // Two-panel layout handled entirely by CSS
    // No JS needed for static split composition
  }


  // ============================================================
  // 4. INVIEW — IntersectionObserver on all .inview elements
  //    Adds .is-inview when element enters viewport
  // ============================================================
  function jtNcInitInview() {
    var els = root.querySelectorAll('.inview');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

    els.forEach(function (el) {
      observer.observe(el);
    });

    // Safety fallback — force any missed inview elements visible after 2s
    setTimeout(function () {
      root.querySelectorAll('.inview:not(.is-inview)').forEach(function (el) {
        el.classList.add('is-inview');
      });
    }, 2000);
  }


  // ============================================================
  // 5. STICKY NO. NAV
  //    Shows after inline no-nav (.jt-nc-no-nav) scrolls out of view
  // ============================================================
  function jtNcInitStickyNoNav() {
    var wrapper   = document.getElementById('jt-nc-sticky-wrapper');
    var inlineNav = root.querySelector('.jt-nc-no-nav');
    if (!wrapper || !inlineNav) return;

    // Move the WRAPPER (containing both navs) to body
    document.body.appendChild(wrapper);

    // Calculate trigger: bottom of inline nav from page top
    function getTriggerY() {
      var el = inlineNav, top = 0;
      while (el) { top += el.offsetTop; el = el.offsetParent; }
      return top + inlineNav.offsetHeight;
    }

    var triggerY = 0;
    setTimeout(function() { triggerY = getTriggerY(); }, 400);

    // Show/hide wrapper via is-visible class
    function onScroll() {
      if (!triggerY) triggerY = getTriggerY();
      wrapper.classList.toggle('is-visible', window.scrollY > triggerY);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }


  // ============================================================
  // 6. STICKY SIDE NAV — section is-current tracker only
  //    Show/hide is handled by jtNcInitStickyNoNav above
  // ============================================================
  function jtNcInitStickySideNav() {
    var stickyNav = document.querySelector('.jt-nc-side-nav-sticky');
    if (!stickyNav) return;
    jtNcTrackSections(stickyNav);
  }


  // ============================================================
  // 7. INLINE SIDE NAV — section is-current tracker
  // ============================================================
  function jtNcInitInlineSideNav() {
    var nav = root.querySelector('.jt-nc-side-nav');
    if (!nav) return;
    jtNcTrackSections(nav);
  }


  // ============================================================
  // SHARED: Section tracker for side navs
  //    Maps anchor href → section element
  //    Adds .is-current to matching li when section is in view
  // ============================================================
  function jtNcTrackSections(nav) {
    var links    = nav.querySelectorAll('a[href^="#"]');
    var sections = [];

    links.forEach(function (link) {
      var id = link.getAttribute('href').replace('#', '');
      var section = document.getElementById(id);
      if (section) {
        sections.push({ link: link, section: section });
      }
    });

    if (!sections.length) return;

    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sections.forEach(function (item) {
          if (item.section === entry.target) {
            if (entry.isIntersecting) {
              // Remove is-current from all, add to matching
              nav.querySelectorAll('li').forEach(function (li) {
                li.classList.remove('is-current');
              });
              if (item.link.parentElement) {
                item.link.parentElement.classList.add('is-current');
              }
            }
          }
        });
      });
    }, { rootMargin: '-40% 0px -40% 0px', threshold: 0 });

    sections.forEach(function (item) {
      sectionObserver.observe(item.section);
    });
  }


  // ============================================================
  // 8. VANILLA CAROUSEL
  //    Handles all .jt-nc-slider instances
  //    Lineup items: main + detail sliders are SYNCED
  //    Mobile: scroll-snap · Desktop: transform-based
  // ============================================================
  var NC_SESSION_KEY = 'jt-nc-slider-state-v1';

  function jtNcGetSliderState() {
    try {
      return JSON.parse(sessionStorage.getItem(NC_SESSION_KEY)) || { SP: {}, PC: {} };
    } catch (e) {
      return { SP: {}, PC: {} };
    }
  }

  function jtNcSaveSliderState(id, index) {
    try {
      var state = jtNcGetSliderState();
      if (!state[device]) state[device] = {};
      state[device][id] = index;
      sessionStorage.setItem(NC_SESSION_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  // Core slider init — returns a goTo function so paired sliders can sync
  function jtNcInitSlider(el, onIndexChange) {
    var id          = el.dataset.id;
    var track       = el.querySelector('.jt-nc-slider__track');
    var slides      = el.querySelectorAll('.jt-nc-slider__slide');
    var dotContainer = el.querySelector('.jt-nc-slider__pagination') || el.parentNode.querySelector('.jt-nc-slider__pagination');
    var slideCount  = slides.length;

    if (!track || slideCount === 0) return null;

    var state    = jtNcGetSliderState();
    var current  = (id && state[device] && state[device][id]) ? state[device][id] : 0;
    var dots     = [];

    function buildDots() {
      if (!dotContainer || slideCount <= 1) return;
      dotContainer.innerHTML = '';
      for (var i = 0; i < slideCount; i++) {
        var dot = document.createElement('span');
        dot.className = 'jt-nc-slider__dot';
        dot.dataset.index = i;
        (function (idx) {
          dot.addEventListener('click', function () { goTo(idx); });
        })(i);
        dotContainer.appendChild(dot);
        dots.push(dot);
      }
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function goTo(index, fromSync) {
      current = Math.max(0, Math.min(index, slideCount - 1));

      if (device === 'SP') {
        var slide = slides[current];
        if (slide) {
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      } else {
        var pct = current * 100;
        var maxPct = (slideCount - 1) * 100;
        track.style.transform = 'translateX(-' + Math.min(pct, maxPct) + '%)';
      }

      updateDots();
      if (id) jtNcSaveSliderState(id, current);

      // Notify paired slider (avoid infinite loop with fromSync flag)
      if (!fromSync && typeof onIndexChange === 'function') {
        onIndexChange(current);
      }
    }

    // Mobile: sync dots with scroll
    if (device === 'SP') {
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var scrollCenter = track.scrollLeft + track.offsetWidth / 2;
          var closest = 0, closestDist = Infinity;
          slides.forEach(function (slide, i) {
            var dist = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - scrollCenter);
            if (dist < closestDist) { closestDist = dist; closest = i; }
          });
          if (closest !== current) {
            current = closest;
            updateDots();
            if (id) jtNcSaveSliderState(id, current);
            if (typeof onIndexChange === 'function') onIndexChange(current);
          }
        }, 60);
      }, { passive: true });
    }

    buildDots();
    goTo(current, true);

    // Return goTo so paired slider can call it
    return function (index) { goTo(index, true); };
  }

  function jtNcInitAllSliders() {
    // 1. Sync paired lineup sliders (main + detail per item)
    var lineupItems = root.querySelectorAll('.js-nc-lineup-set');
    lineupItems.forEach(function (item) {
      var mainEl   = item.querySelector('.jt-nc-slider:not(.jt-nc-slider--detail)');
      var detailEl = item.querySelector('.jt-nc-slider--detail');
      if (!mainEl) return;

      var syncDetail  = null;
      var syncMain    = null;
      var autoTimer   = null;
      var duration    = 7000;
      var slideCount  = mainEl.querySelectorAll('.jt-nc-slider__slide').length;

      function tick(idx) {
        clearTimeout(autoTimer);
        if (slideCount > 1) {
          autoTimer = setTimeout(function () {
            var next = (idx + 1) % slideCount;
            if (syncMain) syncMain(next); // advance main
            if (syncDetail) syncDetail(next); // sync detail explicitly
            tick(next);                   // self-contained loop
          }, duration);
        }
      }

      var obs = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;

        // Init detail first
        if (detailEl) {
          syncDetail = jtNcInitSlider(detailEl, function (idx) {
            if (syncMain) syncMain(idx);
          });
        }

        // Init main — sync detail + restart autoplay on manual change
        syncMain = jtNcInitSlider(mainEl, function (idx) {
          if (syncDetail) syncDetail(idx);
          tick(idx); // restart timer on manual swipe
        });

        tick(0); // kick off autoplay
        obs.disconnect();
      }, { rootMargin: '200px 0px', threshold: 0 });

      obs.observe(item);
    });

    // 2. Basic lineup sliders — autoplay with progress bar sync
    var basicSets = root.querySelectorAll('.js-nc-basiclineup-set');
    basicSets.forEach(function (set) {
      var slider = set.querySelector('.jt-nc-slider');
      if (!slider) return;

      var bars       = set.querySelectorAll('.jt-nc-basiclineup__list-glasses-progress-bar');
      var slideCount = slider.querySelectorAll('.jt-nc-slider__slide').length;
      var duration   = 3000; // ms per slide
      var timer      = null;
      var goTo       = null;
      var total      = slideCount || bars.length;

      function animateBar(idx) {
        // Reset all bars instantly
        bars.forEach(function (b) {
          b.style.transition = 'none';
          b.style.height     = '0%';
        });
        if (!bars[idx]) return;
        // Double rAF to force reflow before applying transition
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            bars[idx].style.transition = 'height ' + duration + 'ms linear';
            bars[idx].style.height     = '100%';
          });
        });
      }

      function tick(idx) {
        clearTimeout(timer);
        animateBar(idx);
        if (total > 1) {
          timer = setTimeout(function () {
            var next = (idx + 1) % total;
            if (goTo) goTo(next); // advance slider
            tick(next);           // continue progress — self-contained, no callback needed
          }, duration);
        }
      }

      // On manual slide change, restart the timer from the new slide
      function onSlideChange(idx) {
        tick(idx);
      }

      var obs = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        goTo = jtNcInitSlider(slider, onSlideChange);
        tick(0); // kick off autoplay
        obs.disconnect();
      }, { rootMargin: '200px 0px', threshold: 0 });

      obs.observe(slider);
    });
  }


  // ============================================================
  // 9. DETAIL SECTION PARALLAX
  //    Each .js-nc-detail-parallax photo shifts vertically on scroll
  //    Strength: ~0.12 of scroll offset (slightly enhanced from JP)
  // ============================================================
  function jtNcInitDetailParallax() {
    if (prefersReducedMotion) return;
    if (device === 'SP') return; // parallax desktop only — mobile stacks

    var photos = root.querySelectorAll('.js-nc-detail-parallax');
    if (!photos.length) return;

    function onScroll() {
      var scrollY = window.pageYOffset;
      photos.forEach(function (photo) {
        var rect   = photo.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        var offset = (window.innerHeight / 2 - center) * 0.12;
        var img    = photo.querySelector('img');
        if (img) {
          img.style.transform = 'translateY(' + offset + 'px)';
        }
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // init on load
  }


  // ============================================================
  // 10. VISUAL MIDDLE PARALLAX
  //     .js-nc-parallax-img shifts at a slower rate than scroll
  // ============================================================
  function jtNcInitMiddleParallax() {
    if (prefersReducedMotion) return;

    var frame = root.querySelector('.js-nc-parallax-frame');
    var img   = root.querySelector('.js-nc-parallax-img');
    if (!frame || !img) return;

    function onScroll() {
      var rect   = frame.getBoundingClientRect();
      var center = rect.top + rect.height / 2 - window.innerHeight / 2;
      var offset = center * 0.12;
      img.style.transform = 'translateY(' + offset + 'px)';
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }


  // ============================================================
  // RANDOM VISUAL VARIANT SELECTION
  // Picks a random variant (1–6) for visual-middle and visual-bottom
  // on each page load — matches JP behaviour
  // ============================================================
  function jtNcInitRandomVisuals() {
    var cdn      = 'https://cdn.shopify.com/s/files/1/0562/8903/4283/files/';
    var variant  = Math.floor(Math.random() * 6) + 1; // 1–6

    var middle = root.querySelector('.jt-nc-visual-middle__visual .js-nc-parallax-img');
    if (middle) {
      middle.src = cdn + 'newclassic-visual-middle-' + variant + '.webp';
    }

    var bottom = root.querySelector('.jt-nc-visual-bottom__visual img');
    if (bottom) {
      bottom.src = cdn + 'newclassic-visual-bottom-' + variant + '.webp';
    }
  }


  // ============================================================
  // INIT — Run all modules
  // ============================================================
  jtNcInitKV();
  jtNcInitInview();
  jtNcInitStickyNoNav();
  jtNcInitStickySideNav();
  jtNcInitInlineSideNav();
  jtNcInitAllSliders();
  jtNcInitDetailParallax();
  // ============================================================
  // CUSTOM CURSOR — JP-style editorial dot + follower
  // Desktop only. Expands to mix-blend-mode:difference on hover
  // Targets: look thumbs, carousel images, KV
  // ============================================================
  function jtNcInitCustomCursor() {
    // Skip on touch/mobile devices
    if (window.matchMedia('(max-width: 767px)').matches) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;

    var cursor   = document.getElementById('jt-nc-cursor');
    var follower = document.getElementById('jt-nc-cursor-follower');
    if (!cursor) return;

    var mouseX = -200, mouseY = -200;
    var followerX = -200, followerY = -200;

    // Use left/top — CSS translate(-50%,-50%) keeps center on cursor regardless of size
    document.addEventListener('mousemove', function (e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      cursor.style.left = mouseX + 'px';
      cursor.style.top  = mouseY + 'px';
    });

    // Follower lags behind with rAF lerp
    function animateFollower() {
      followerX += (mouseX - followerX) * 0.12;
      followerY += (mouseY - followerY) * 0.12;
      if (follower) {
        follower.style.left = followerX + 'px';
        follower.style.top  = followerY + 'px';
      }
      requestAnimationFrame(animateFollower);
    }
    animateFollower();

    // Hover targets — all major imagery areas across the page
    var hoverSelectors = [
      '.jt-nc-kv',
      '.jt-nc-detail__photo',
      '.jt-nc-lineup__main-photo',
      '.jt-nc-lineup__detail',
      '.jt-nc-lineup__list-glasses',
      '.jt-nc-basiclineup__main-photo',
      '.jt-nc-basiclineup__list-glasses',
      '.jt-nc-visual-middle',
      '.jt-nc-visual-bottom',
      '.jt-nc-lookthumb__look'
    ].join(', ');

    document.addEventListener('pointerover', function (e) {
      if (e.target.closest(hoverSelectors)) {
        cursor.classList.add('is-active');
      }
    });

    document.addEventListener('pointerout', function (e) {
      if (e.target.closest(hoverSelectors)) {
        cursor.classList.remove('is-active');
      }
    });

    // Hide on page leave
    document.addEventListener('mouseleave', function () {
      cursor.style.opacity = '0';
      follower.style.opacity = '0';
    });
    document.addEventListener('mouseenter', function () {
      cursor.style.opacity = '';
      follower.style.opacity = '';
    });
  }

  jtNcInitRandomVisuals();
  jtNcInitMiddleParallax();
  jtNcInitCustomCursor();

});
